import React, { Component } from 'react'
import OrgFooter from '../widgets/OrgFooter'
import Board from '../widgets/Board'
import Card from '../widgets/Card'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'
import APIFarmerRequest from '../api/APIFarmerRequest'
import InputSearchWidget from '../widgets/InputSearchWidget'
import APIOtherProjectRequest from '../api/APIOtherProjectRequest'

class BeneficiaryFarmers extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			siteId: localStorage.getItem("siteId"),
			scrollable: false,
			projectId: props.pid,
			beneficiaries: {},
			isViewDetails: props.isViewDetails,
			draggable: props.isViewDetails
		}
		this.setScrollable = this.setScrollable.bind(this)
		this.getAllFarmersBySiteId = this.getAllFarmersBySiteId.bind(this)
		this.addBeneficiary = this.addBeneficiary.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
		this.addProjectFarmerByProjectId = this.addProjectFarmerByProjectId.bind(this)
		this.editProjectFarmerByProjectId = this.editProjectFarmerByProjectId.bind(this)
		this.getAllProjectFarmerByProjectId = this.getAllProjectFarmerByProjectId.bind(this)
	}

	onSubmit() {
		this.setState({showActivityIndicator: true})
		const members = []
		const addMembers = []
		const deleteMembers = []
		Object.values(this.state.beneficiaries).forEach((v) => {
			if(v.position_id == 0) {
				delete v.position_id
				deleteMembers.push(v)
			}
			else if(v.id == null) {
				delete v.position_id
				addMembers.push(v)
			}
			else {
				delete v.position_id
				members.push(v)
			}
		})
		if(members.length < 1 && deleteMembers.length < 1) {
			const data = {otherProjectFarmerBeneficiary: addMembers}
			this.addProjectFarmerByProjectId(data)
		}
		else {
			const data = {}
			if(members.length > 0) {
				data["otherProjectFarmerBeneficiary"] = members
			}
			if(addMembers.length > 0) {
				data["add"] = {} 
				data["add"]["otherProjectFarmerBeneficiary"] = addMembers
			}
			if(deleteMembers.length > 0) {
				data["delete"] = {} 
				data["delete"]["otherProjectFarmerBeneficiary"] = deleteMembers
			}
			this.editProjectFarmerByProjectId(data)
		}
	}

	addProjectFarmerByProjectId(data) {
		const apiReq = APIOtherProjectRequest.addProjectFarmerByProjectId(this.state.accessToken, data, this.state.projectId)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.error,
					showActivityIndicator: false
				})
				return
			}
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + response.description,
				showActivityIndicator: false
			})
		})
	}

	editProjectFarmerByProjectId() {
	}

	componentWillMount() {
		this.getAllProjectFarmerByProjectId((fb) => {
			this.getAllFarmersBySiteId(fb)
		})
	}

	getAllProjectFarmerByProjectId(callback) {
		this.setState({showActivityIndicator: true})
		const orgs = APIOtherProjectRequest.getAllProjectFarmerByProjectId(this.state.accessToken, this.state.projectId);
		orgs.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			const farmerIds = []
			const farmerBenes = []
			for(const v of response.results.rows) {
				farmerIds.push(v.farmer_id)
				if(v.middle_name != null) {
					var mi = v.middle_name.charAt(0)
				}
				const extn = (v.extension_name != null)? v.extension_name: ""
				const name = v.last_name + ", " + v.first_name + " " + extn + " " + mi
				farmerBenes.push(<Card id={"card-"+v.farmer_id} className="card"
					draggable={!this.state.isViewDetails}>{name.toUpperCase()}</Card>)
			}
			this.setState({farmerBenes: farmerBenes})
			callback(farmerIds)
		})
	}

	getAllFarmersBySiteId(farmerBenes) {
		this.setState({showActivityIndicator: true})
		const allFarmers = APIFarmerRequest.getAllFarmersBySiteId(this.state.accessToken, this.state.siteId)
		allFarmers.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			const farmers = []
			for(const v of response.results.rows) {
				if(farmerBenes.includes(v.farmer_id)) {
					continue
				}
				if(v.middle_name != null) {
					var mi = v.middle_name.charAt(0)
				}
				const extn = (v.extension_name != null)? v.extension_name: ""
				const name = v.last_name + ", " + v.first_name + " " + extn + " " + mi
				farmers.push(<Card id={"card-"+v.farmer_id} className="card"
					draggable={!this.state.isViewDetails}>{name.toUpperCase()}</Card>)
			}
			this.setState({farmers: farmers, showActivityIndicator: false})
		})
	}


	componentDidMount() {
		window.addEventListener('resize', this.onResize.bind(this))
		this.setScrollable()
		this.setState({boardHeight: window.innerHeight - 440})
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize.bind(this))
	}

	onResize() {
		this.setScrollable()
		this.setState({boardHeight: window.innerHeight - 440})
	}

	setScrollable() {
		const sa = document.getElementById('bo-scroll-area')
		const ca = document.getElementById('bo-client-area')
		if(ca == null || sa == null) {
			return
		}
		if(sa.clientHeight < ca.clientHeight+54) {
			this.setState({scrollable: true})
		}
		else {
			this.setState({scrollable: false})
		}
	}

	addBeneficiary(id, pid) {
		const fid = id.split('-')[1]
		this.state.beneficiaries[fid] = {
			id: fid[2],
			farmer_id: fid,
			position_id: pid
		}
	}

	render() {
		const b1Height = this.state.boardHeight + "px"
		const b2Height = this.state.boardHeight + 40 +"px"
		const view = <div id="beneficiary-org">
			<div id="bo-scroll-area"><div id="bo-client-area">
				<div id="bo-cell1">
					<div>Project Name</div>
					<input type="text" placeholder={this.props.projectName} disabled="true" />
				</div>
				<div className="title-bar">BENEFICIARIES</div>
				<div id="bo-cell2">
					<div id="bo-cell2-c1">
						<div className="lbl-board">FARMERS</div>
						<InputSearchWidget placeholder="SEARCH BY NAME OR REGISTRATION ID" cStyle={{'width': '100%', 'margin-top': '10px'}}
							onSearchClick={(value) => {
							}}
							onEnterPress={(value) => {
							}}
						/>
						<div id="bf-cell-board1">
							<Board id="board-1" className="board" onCardAdded={(id, text) => {
								this.addBeneficiary(id, 0)
							}} style={b1Height} list={this.state.farmers}></Board>
						</div>
					</div>
					<div id="bo-cell2-c2">
						<div className="lbl-board">BENEFICIARIES</div>
						<div id="bf-cell-board2">
							<Board id="board-2" className="board" onCardAdded={(id, text) => {
								this.addBeneficiary(id, 1)
							}} style={b2Height} list={this.state.farmerBenes}></Board>
						</div>
					</div>
				</div>

			</div>{this.state.scrollable === true && <OrgFooter submit={this.onSubmit}
			showSubmit={true} disabled={this.state.isViewDetails} />}</div>
			{this.state.scrollable === false && <div className="alternate-footer">
					<OrgFooter submit={this.onSubmit} disabled={this.state.isViewDetails} showSubmit={true} /></div>}
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					this.setState({showInfoMessage: false, shouldDisplayValues: true})
			}} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

export default BeneficiaryFarmers
